import TalkIcon from '../assets/images/icons/talk-icon.png';
import ThinkIcon from '../assets/images/icons/think-icon.png';
import CreateIcon from '../assets/images/icons/create-icon.png';
import DesignIcon from '../assets/images/icons/design-icon.png';
import DeliveryIcon from '../assets/images/icons/delivery-icon.png';

export const processItems = [
    {
        name: 'Talk',
        description: 'We like to talk, it’s the best way to understand the project and set out goals to produce amazing work',
        icon: TalkIcon 
    },
    {
        name: 'Think',
        description: 'The key to any successful project is highlighting the opportunities that exist for you to stand out in a unique way. Understanding your audience and what drives them is fundamental to engaging them on multiple platforms',
        icon: ThinkIcon 
    },
    {
        name: 'Create',
        description: 'We like to explore a variety of ideas, creating different concepts to produce the best creative work',
        icon: CreateIcon 
    },
    {
        name: 'Design',
        description: 'Putting our ideas into visuals and bringing them to life is where our passion lies. We enjoy making you look great and growing your business through engaging design',
        icon: DesignIcon 
    },
    {
        name: 'Delivery',
        description: 'Any project we work is always on time, on brief and on budget',
        icon: DeliveryIcon 
    },
    
]